module.exports = __webpack_public_path__ + "img/ppcbank_mobile.6ae77763.jpg";